module.exports = __webpack_public_path__ + "static/media/headphones.776e126a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/headphones.png
 ** module id = 1301
 ** module chunks = 0
 **/